"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pascalCase = void 0;
var _upperFirst2 = _interopRequireDefault(require("lodash/upperFirst"));
var _camelCase2 = _interopRequireDefault(require("lodash/camelCase"));
var _flow2 = _interopRequireDefault(require("lodash/flow"));
var pascalCase = exports.pascalCase = (0, _flow2["default"])(_camelCase2["default"], _upperFirst2["default"]);